import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { connect } from 'react-redux';

import dateTimeService from '../../services/DateTimeService';
import TestComponents from './TestComponents';
import sessionConstants from '../../constants/SessionConstants';
import timeReader from '../../store/readHelpers/TimeReader';
import sessionReader from '../../store/readHelpers/SessionReader';
import PendingFileDeliveryStatus from './PendingFileDeliveryStatus';

import styles from './testOverview.scss';
import fileDeliveryUploader from '../../services/FileDeliveryUploader';
import preCheckService from '../../services/PreCheckService';

class TestOverview extends React.PureComponent {
    static propTypes = {
        cacheStatus: PropTypes.object.isRequired,
        isOnline: PropTypes.bool.isRequired,
        offlineFileDeliveryStatus: PropTypes.object.isRequired,
        parentTest: PropTypes.object.isRequired,
        standaloneTest: PropTypes.object,
        timeHasExpired: PropTypes.bool.isRequired,
        navigationLock: PropTypes.object.isRequired,
        direction: PropTypes.string.isRequired,
        pendingAssessments: PropTypes.object.isRequired,
        livestream: PropTypes.object.isRequired,
        readinessCheck: PropTypes.object.isRequired,
        remoteOralExamSessionInfo: PropTypes.object,
    };

    render() {
        const {
            direction,
            parentTest,
            isOnline,
            offlineFileDeliveryStatus,
        } = this.props;
        const startDateMoment = moment(parentTest.startTime, sessionConstants.SIMPLE_DATE_FORMAT);
        const pendingFileDeliveries = fileDeliveryUploader.getPendingFileDeliveries(offlineFileDeliveryStatus);

        return (
            <div className={styles.wrapper}>
                {
                    pendingFileDeliveries.length > 0 ?
                        <PendingFileDeliveryStatus pendingFileDeliveries={pendingFileDeliveries} isOnline={isOnline} />
                        : null
                }
                <div className={styles.body} role="main" dir={direction}>
                    <h2>{parentTest.title}</h2>
                    <div className={styles.date}>
                        <span>{dateTimeService.formatDate(startDateMoment.toDate())}</span>
                        <hr />
                    </div>
                    <TestComponents {...this.props} />
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        allShownChecksCompleted: preCheckService.allShownChecksCompleted(),
        cacheStatus: state.cacheStatus,
        direction: state.ui.direction,
        idverification: state.idverification,
        isOnline: state.api.isOnline,
        isServerOK: state.api.isServerOK,
        livestream: state.livestream,
        navigationLock: state.session.navigationLock,
        offlineFileDeliveryStatus: state.delivering.offlineFileDeliveryStatus || {},
        parentTest: state.parentTest,
        pendingAssessments: state.pendingAssessments,
        readinessCheck: state.readinessCheck,
        remoteOralExam: state.remoteOralExam,
        standaloneTest: !sessionReader.isParentTest() ? state.assessment : null, // Mind this lacks field status=testStatusConstants.EXECUTING
        timeHasExpired: timeReader.timeHasExpired(),
    };
}

const TestOverviewContainer = connect(mapStateToProps)(TestOverview);
export default TestOverviewContainer;
